import { useMsal } from '@azure/msal-react'
import * as React from 'react'

import Loader from '../components/Loader'
import HomePage from '../pages/HomePage'
import Login from '../pages/Login/LoginPage'
import { UserProfile } from '../types'

interface MainContentProps {
  userData?: UserProfile | undefined
}

const MainContent = ({ userData }: MainContentProps) => {
  const { accounts, inProgress } = useMsal()

  // Show loading while MSAL is initializing
  if (inProgress !== 'none') {
    return <Loader />
  }

  // Show login if no accounts
  if (!accounts.length) {
    return <Login />
  }

  // Show HomePage if authenticated
  return <HomePage username={accounts[0].username} userData={userData} />
}

export default MainContent
